/**
 * Torn weapon types - Primary, Secondary, Melee, Temporary.
 * Used for filter dropdown.
 */
export const WEAPON_TYPES = [
  'Primary',
  'Secondary',
  'Melee',
].sort((a, b) => a.localeCompare(b));
